import React, {Component} from 'react'
import '../styles/Koszyk.css'
import {Button} from "react-bootstrap";
import acc from 'accounting'
import {Link} from "react-router-dom";
import strings from '../strings/localeStrings'
import $ from "jquery";
import moment from "moment";

export default class Koszyk extends Component {

    constructor(props) {
        super(props);

        let data;

        if (sessionStorage.getItem('koszyk') === null || sessionStorage.getItem('koszyk') === '') {
            data = [];
        } else {
            data = JSON.parse(sessionStorage.getItem('koszyk'))
        }

        this.state = {
            data: data,
            email: '',
            odliczanie: '...'
        };

        this.handleDelete = this.handleDelete.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this)
    }

    componentDidMount() {
        this.timer = setInterval(() => this.odliczanie(), 1000)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({data: JSON.parse(sessionStorage.getItem('koszyk'))})
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    odliczanie() {
        if (this.state.data !== '' && this.state.data !== null && this.state.data !== [] && this.state.data.length !== 0) {
            let timer = moment(sessionStorage.getItem('koszykTimer')).add(-1, 'seconds').format('mm:ss');
            if (timer === 'Invalid date') {
                timer = '...'
            }
            this.setState({
                odliczanie: timer,
                data: JSON.parse(sessionStorage.getItem('koszyk'))
            })
        }
    }

    handleEmailChange(e) {
        this.setState({email: e.target.value})
    }

    handleDelete(item) {
        let array = JSON.parse(sessionStorage.getItem('koszyk'));

        for (let i = 0; i < array.length; i++) {
            if (array[i].id === item.id) {
                array.splice(i, 1);
            }
        }

        sessionStorage.setItem('koszyk', JSON.stringify(array));
        this.setState({data: array});
        this.props.odswiezPozycje();
        this.props.koszyk();
    }

    getCenaKoncowa() {
        let cenaKoncowa = 0;
        for (let i = 0; i < this.state.data.length; i++) {
            cenaKoncowa = cenaKoncowa + this.state.data[i].cena
        }
        return cenaKoncowa
    }

    getTypKoszyka() {
        if (sessionStorage.getItem('koszyk') !== '[]' && sessionStorage.getItem('koszyk') !== null) {
            if (JSON.parse(sessionStorage.getItem('koszyk'))[0].statPoz === -1) {
                return strings.zakup
            } else {
                return strings.rezerwacja
            }
        } else {
            return '0'
        }
    }

    iloscBiletow() {
        let koszyk = JSON.parse(sessionStorage.getItem('koszyk'));

        let ilosc = 0;

        for (let i = 0; i < koszyk.length; i++) {
            if (koszyk[i].idKuPrze !== null) {
                ilosc = ilosc + 2
            } else {
                ilosc++
            }
        }

        return ilosc;
    }

    getPodsumowanie() {
        let koszyk = JSON.parse(sessionStorage.getItem('koszyk'));

        let cena = 0;

        for (let i = 0; i < koszyk.length; i++) {
            if (koszyk[i].idKuPrze !== null) {
                cena = cena + koszyk[i].cena + koszyk[i].cena2
            } else {
                cena = cena + koszyk[i].cena
            }
        }

        return cena;
    }

    getCzasOczekiwania(item) {
        let wynikGodz = moment(moment(item.godzPrze, 'H:mm').diff(moment(item.godzPrzyPrze, 'H:mm'))).format('HH');
        let wynikMin = moment(moment(item.godzPrze, 'H:mm').diff(moment(item.godzPrzyPrze, 'H:mm'))).format('mm');
        let iloscMin = wynikMin;
        wynikMin = item.czasOczek;
        let minuty = 'minut';

        if (wynikMin === 1) {
            minuty = 'minuta'
        }
        //
        // let lastDigit = wynikMin.toString().split('').pop()
        //
        // if (lastDigit === "2" || lastDigit === "3" || lastDigit === "4") {
        //     minuty = 'minuty'
        // }

        return <span><i className="fa fa-arrows-v"/> {parseInt(wynikGodz) - 1} godz. {parseInt(iloscMin)} min</span>
    }

    getStanKoszyka() {
        return JSON.parse(sessionStorage.getItem('koszyk')) !== null && JSON.parse(sessionStorage.getItem('koszyk')) !== undefined ? JSON.parse(sessionStorage.getItem('koszyk')).length : '0'
    }

    finalizujTransakcje() {
        // localStorage.setItem('finalizacja', JSON.stringify(this.state.data))
        // let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // if (re.test(this.state.email)) {
        //     this.setState({
        //         nieprawidlowyEmail: false
        //     })
        //     this.postBilety()
        // } else {
        //     this.setState({
        //         nieprawidlowyEmail: true
        //     })
        // }
    }

    render() {
        // return <div className="col-sm-2" style={ $("#koszykHeight").height() > $("#container").height() - 200 ? {overflow: 'scroll', maxHeight: $("#container").height() - 50} : {overflow: 'none'} }>
        return <div className="col-sm-2 koszykMobilka">
            <div
                className={this.props.position > 240 && $("#koszykHeight").height() < $("#container").height() - 200 ? "sticky koszyk" : "koszyk"}
                style={this.props.position > 240 ? {top: this.props.position - 240} : null}>

                {this.state.data !== null && this.state.data.length !== 0 ?
                    <div id="koszykHeight">
                        {this.state.data.map((item, index) => {
                            return (<div>
                                    {item.idKuPrze === null ?
                                        <div className="wynik row" style={{fontSize: 12.5}}>
                                            <div className="col-sm-11">
                                                <div className="koszykLabel"><i
                                                    className='fa fa-xs fa-times'
                                                    style={{
                                                        float: 'right',
                                                        paddingTop: 4,
                                                        color: 'red',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => this.handleDelete(item)}> </i>
                                                </div>
                                                <div className="koszykLabel"
                                                     style={{textAlign: 'center'}}>{this.getTypKoszyka()}</div>
                                                <hr style={{marginTop: 2, marginBottom: 5}}/>
                                                <div className="row koszykRow">
                                                    <div className="col-sm-1">
                                                        <i className="fa fa-road"
                                                           aria-hidden="true"> </i></div>
                                                    <div className="col-sm-10"> {item.nazMiOd} - {item.nazMiDo}</div>
                                                </div>
                                                <div className="row koszykRow">
                                                    <div className="col-sm-1">
                                                        <i className="fa fa-calendar"
                                                           aria-hidden="true"> </i></div>
                                                    <div className="col-sm-10"> {item.data.substr(0, 10)}</div>
                                                </div>
                                                <div className="row koszykRow">
                                                    <div className="col-sm-1">
                                                        <i className="fa fa-clock-o" aria-hidden="true"> </i></div>
                                                    <div className="col-sm-10"> {item.godz}</div>
                                                </div>
                                                <div className="row koszykRow">
                                                    <div className="col-sm-1"><i className="fa fa-money"
                                                                                 aria-hidden="true"> </i></div>
                                                    <div className="col-sm-10">{acc.formatMoney(item.cena, {
                                                        symbol: 'zł',
                                                        format: '%v %s'
                                                    })}</div>
                                                </div>
                                                <div className="row koszykRow">
                                                    <div className="col-sm-1"><i className="fa fa-user"
                                                                                 aria-hidden="true"> </i>
                                                    </div>
                                                    <div className="col-sm-10"> {item.klient}</div>
                                                </div>
                                                <div className="row koszykRow">
                                                    <div className="col-sm-1"><i className="fa fa-ticket"
                                                                                 aria-hidden="true"> </i>
                                                    </div>
                                                    <div className="col-sm-10"> {item.rodzaj}</div>
                                                </div>
                                            </div>
                                        </div> :
                                        <div>
                                            <div className="wynik row" style={{fontSize: 12.5}}>
                                                <div className="col-sm-11">
                                                    <div className="koszykLabel"><i
                                                        className='fa fa-xs fa-times'
                                                        style={{
                                                            float: 'right',
                                                            paddingTop: 4,
                                                            color: 'red',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => this.handleDelete(item)}> </i>
                                                    </div>
                                                    <div className="koszykLabel"
                                                         style={{textAlign: 'center'}}>{this.getTypKoszyka()}</div>
                                                    <hr style={{marginTop: 2, marginBottom: 5}}/>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1">
                                                            <i className="fa fa-road"
                                                               aria-hidden="true"> </i></div>
                                                        <div
                                                            className="col-sm-10"> {item.nazMiOd} - {item.nazMiPrze}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1">
                                                            <i className="fa fa-calendar"
                                                               aria-hidden="true"> </i></div>
                                                        <div className="col-sm-10"> {item.data.substr(0, 10)}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1">
                                                            <i className="fa fa-clock-o" aria-hidden="true"> </i></div>
                                                        <div className="col-sm-10"> {item.godz}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1"><i className="fa fa-money"
                                                                                     aria-hidden="true"> </i></div>
                                                        <div className="col-sm-10">{acc.formatMoney(item.cena, {
                                                            symbol: 'zł',
                                                            format: '%v %s'
                                                        })}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1"><i className="fa fa-user"
                                                                                     aria-hidden="true"> </i>
                                                        </div>
                                                        <div className="col-sm-10"> {item.klient}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1"><i className="fa fa-ticket"
                                                                                     aria-hidden="true"> </i>
                                                        </div>
                                                        <div className="col-sm-10"> {item.rodzaj}</div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 text-center" style={{
                                                    fontSize: '0.75rem',
                                                    color: '#858585',
                                                    marginTop: 5,
                                                    marginBottom: 5
                                                }}>
                                                    {this.getCzasOczekiwania(item)}
                                                </div>
                                                <div className="col-sm-11">
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1">
                                                            <i className="fa fa-road"
                                                               aria-hidden="true"> </i></div>
                                                        <div
                                                            className="col-sm-10"> {item.nazMiPrze} - {item.nazMiDo}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1">
                                                            <i className="fa fa-calendar"
                                                               aria-hidden="true"> </i></div>
                                                        <div
                                                            className="col-sm-10"> {item.dataOdjPrze.substr(0, 10)}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1">
                                                            <i className="fa fa-clock-o" aria-hidden="true"> </i></div>
                                                        <div className="col-sm-10"> {item.godzPrze}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1"><i className="fa fa-money"
                                                                                     aria-hidden="true"> </i></div>
                                                        <div className="col-sm-10">{acc.formatMoney(item.cena2, {
                                                            symbol: 'zł',
                                                            format: '%v %s'
                                                        })}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1"><i className="fa fa-user"
                                                                                     aria-hidden="true"> </i>
                                                        </div>
                                                        <div className="col-sm-10"> {item.klient}</div>
                                                    </div>
                                                    <div className="row koszykRow">
                                                        <div className="col-sm-1"><i className="fa fa-ticket"
                                                                                     aria-hidden="true"> </i>
                                                        </div>
                                                        <div className="col-sm-10"> {item.rodzaj2}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            )
                        })}
                        <div className="row" style={{paddingTop: 10}}>
                            <div className="col-sm-12 text-center" style={{fontSize: '0.75rem'}}>Koszyk wygaśnie
                                za: <font
                                    color="red">{this.state.odliczanie}</font>
                            </div>
                            <div className="col-sm-12">
                                <Link to='/koszyk'><Button bsStyle={'success'}
                                                           onClick={() => console.log(this.finalizujTransakcje())}>{strings.przejdzDoKoszyka}</Button></Link>
                            </div>
                            <div className="col-sm-12 podsumowanie" style={{paddingTop: 5}}>Ilość pozycji: <font
                                color="green">{this.iloscBiletow()}</font>
                            </div>
                            <div className="col-sm-12 podsumowanie">{strings.podsumowanie}:</div>
                            <div className="col-sm-12 podsumowanie">
                                <font color="green"> {acc.formatMoney(this.getPodsumowanie(), {
                                    symbol: 'zł',
                                    format: '%v %s'
                                })}</font>
                            </div>
                        </div>
                    </div> :
                    <div className="wynik">
                        <div className="koszykPusty" id="koszykHeight">
                            <h4>{strings.koszykPusty}</h4>
                        </div>
                    </div>}
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/koszyk/Koszyk.js